import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Meisterkachel from '../../components/Meisterkachel/Meisterkachel';

import DealerInfo from '../../components/DealerInfo/DealerInfo';
import BreadCrumbSelector from '../../components/BreadCrumb/BreadCrumbSelector';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import { withCookies } from 'react-cookie';
import { standortUrlSelector } from '../../../modules/selectors/url';
import Image, { useFallbackImageSrc } from '../../components/Image/Image';
import { frontloadConnect } from 'react-frontload';
import { dienstleistungResponseSelector } from '../../../modules/selectors/standort/service/dienstleistung';
import { fetchDienstleistungIfNeeded } from '../../../modules/actions/standort/service/dienstleistung';
import ReduxSuspense from '../../components/ReduxSuspense/ReduxSuspense';
import { taxLabel } from '../../../helpers/taxHelper';
import { trackEvent } from '../../components/Tracking/Matomo';
import { sessionIdSelector } from '../../../modules/selectors/auth';
import Currency from '../../../helpers/currency';
import Button from '../../components/form-elements/Button';
import LegacyShopWrapper from '../../LegacyShopWrapper';
import withStandortRouter from '../../components/VHost/withStandortRouter';
import { addService } from '../../../modules/actions/standort/session/cart';

const ServiceImage = ({ dienstleistung, markenStandort }) => {
    const [showBigImage, setShowBigImage] = useState(false);
    const toggleShowBigImage = () => setShowBigImage(!showBigImage);

    const fallbackSrc = `https://techno-images.s3.eu-central-1.amazonaws.com/standort-images/${markenStandort.gesellschafterNr}/${markenStandort.standortNr}/Logo.jpg`;

    const [dienstleistungImageSrc, dienstleistungImageOnError] = useFallbackImageSrc({
        src: dienstleistung.bilddatei,
        fallbackSrc,
    });

    return (
        <>
            {/* Bilder */}
            <div className="picture col-sm-3">
                <div className="image_wrapper">
                    <div className="main_image col-xs-12">
                        {dienstleistung?.bilddatei ? (
                            <Image
                                alt="Serviceleistung"
                                onClick={toggleShowBigImage}
                                className="image_inner"
                                src={dienstleistungImageSrc}
                                onError={dienstleistungImageOnError}
                                resizeWidth={700}
                            />
                        ) : (
                            <Image
                                alt="Serviceleistung"
                                onClick={toggleShowBigImage}
                                className="image_inner"
                                src={fallbackSrc}
                                resizeWidth={700}
                            />
                        )}
                        <div style={{ clear: 'both' }} />
                    </div>
                    <span onClick={toggleShowBigImage} className="fa fa-search-plus" onKeyPress={(e) => e.key === 'Enter' && toggleShowBigImage()} tabIndex={0} aria-label="Bild vergrößern" role='button' />
                </div>
                <div style={{ clear: 'both' }} />
            </div>
            {showBigImage && (
                <div className="image_big">
                    <div className="image_inner">
                        {dienstleistung?.bilddatei ? (
                            <Image
                                alt="Serviceleistung"
                                className="image_inner"
                                src={dienstleistungImageSrc}
                                onError={dienstleistungImageOnError}
                                resizeWidth={1000}
                            />
                        ) : (
                            <Image alt="Serviceleistung" className="image_inner" src={fallbackSrc} resizeWidth={1000} />
                        )}
                        <span onClick={toggleShowBigImage} className="fa fa-times" onKeyPress={(e) => e.key === 'Enter' && toggleShowBigImage()} tabIndex={0} aria-label="Bild verkleinern" role='button' />
                        <div style={{ clear: 'both' }} />
                    </div>
                </div>
            )}
        </>
    );
};

class ServiceDetail extends React.Component {
    constructor(props) {
        super(props);

        this.addServiceToCart = this.addServiceToCart.bind(this);
    }

    addServiceToCart(event, service) {
        event.preventDefault();
        const { addService, history } = this.props;
        trackEvent({
            category: 'E-Commerce',
            action: 'Lege-in-Warenkorb',
            label: `${service.fahrzeugBeschreibung}_${service.serviceTitle}`,
        });
        addService({ service })
            .then(() => history.push(`/initiateCheckout?type=reservierung`))
            .catch(error => window.UIkit.notification(error, { status: 'danger', pos: 'top-right' }));
    }

    /*********************************
     * Methode um einen (URL-)String
     * in einen Title zu convertieren
     *********************************/
    titlfyString(string) {
        if (string) {
            // Ö Ä Ü
            let resultString = string.replace(/ue/g, 'ü').replace(/oe/g, 'ö').replace(/ae/g, 'ä');
            // Erster Buchstabe groß
            return resultString.charAt(0).toUpperCase() + resultString.slice(1);
        } else return string;
    }

    render() {
        const { markenStandort, serviceUrl, dienstleistungResponse } = this.props;

        return (
            <>
                <BreadCrumbSelector
                    additionalCrumbs={[
                        { url: `/reparatur-wartung/${serviceUrl}`, label: this.titlfyString(serviceUrl) },
                        { label: 'Serviceleistung' },
                    ]}
                />
                <ReduxSuspense response={dienstleistungResponse}>
                    {dienstleistung => (
                        <>
                            <LegacyShopWrapper>
                                <div className="service_details_wrapper">
                                    <div className="detail_content">
                                        <div className="row detail col-xs-12" style={{ paddingRight: '5px', position: 'relative' }}>
                                            <div className="background col-xs-12">
                                                <ServiceImage dienstleistung={dienstleistung} markenStandort={markenStandort} />
                                                <div className="info_text col-md-6 col-sm-9">
                                                    <div className="head">
                                                        <h2>
                                                            <div>{dienstleistung.serviceCategory.serviceTitle}</div>
                                                        
                                                            {markenStandort.implementsAreaConcept ? (
                                                                <span className="car_for_service">
                                                                    {dienstleistung.hauptFabrikat} - {dienstleistung.fahrzeugBeschreibung}
                                                                </span>
                                                            ) : (
                                                                <span className="car_for_service">
                                                                    {markenStandort.hauptFabrikat} - {dienstleistung.fahrzeugBeschreibung}
                                                                </span>
                                                            )}
                                                        </h2>
                                                    </div>
                                                    <div className="col-md-12 angebots_bullet">
                                                        <ul>
                                                            {dienstleistung.angebotsBulletPoints
                                                                ? dienstleistung.angebotsBulletPoints.map(angebotsBulletPoint => (
                                                                      <li
                                                                          className="col-md-12"
                                                                          key={dienstleistung.angebotsBulletPoints.indexOf(
                                                                              angebotsBulletPoint
                                                                          )}
                                                                          dangerouslySetInnerHTML={{ __html: angebotsBulletPoint }}
                                                                      />
                                                                  ))
                                                                : null}
                                                        </ul>
                                                        <div className="werkstatt-hinweis">
                                                            <div className="hinweis_image">
                                                                <Image
                                                                    alt="Hinweis"
                                                                    src="https://techno-images.s3.eu-central-1.amazonaws.com/icons/Werkstatt-Hinweis.png"
                                                                />
                                                            </div>
                                                            <div className="hinweis_list">
                                                                <ul>
                                                                    {dienstleistung?.markenStandort?.vorteilskommunikation?.map?.(
                                                                        (vorteil, i) => <li key={i}>{vorteil}</li>
                                                                    ) ?? null}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="main_kasse col-md-3 col-xs-12">
                                                    <div className="box">
                                                        <div className="price">
                                                            <div className='value'>
                                                                <strong><Currency quantity={dienstleistung.preis.komplettPreis} /></strong>
                                                            </div>
                                                            <em><p>Preis inkl. {taxLabel()} MwSt.</p></em>
                                                        </div>
                                                        <div className="montage_box">
                                                            <sup>*</sup>
                                                            <em id="komplettpreis-hinweis">Komplettpreis inklusive Teile und Arbeitszeit</em>
                                                            <br />
                                                            <sup>*</sup>
                                                            <em id="termin-hinweis">Terminvereinbarung im Bestellprozess</em>
                                                            <br />
                                                        </div>
                                                        <div className="order">
                                                            <Button
                                                                onClick={event => {
                                                                    this.addServiceToCart(event, dienstleistung);
                                                                }}
                                                                ariaLabel={`${dienstleistung.serviceCategory.serviceTitle} ${dienstleistung.hauptFabrikat} ${dienstleistung.fahrzeugBeschreibung} Reservieren`}
                                                                ariaDescribedBy="komplettpreis-hinweis termin-hinweis"
                                                            >
                                                                Reservieren
                                                            </Button>
                                                        </div>
                                                    </div>
                                                    <div className="bottom_text">
                                                        <div className="vorteilskommunikation">
                                                            <i className="fa fa-check" aria-hidden="true" />
                                                            <div>Terminvereinbarung im Bestellprozess</div>
                                                        </div>
                                                        <div className="vorteilskommunikation">
                                                            <i className="fa fa-check" aria-hidden="true" />
                                                            <div>Zuverlässiger Service</div>
                                                        </div>
                                                        <div className="vorteilskommunikation">
                                                            <i className="fa fa-check" aria-hidden="true" />
                                                            <div>Ersatzwagen auf Wunsch zubuchbar</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </LegacyShopWrapper>
                            {!markenStandort.isTechno && <DealerInfo />}
                            <section className="uk-section uk-section-muted uk-section-small">
                                <div className="uk-container uk-container-xsmall">
                                    <Meisterkachel />
                                </div>
                            </section>
                        </>
                    )}
                </ReduxSuspense>
            </>
        );
    }
}

const frontload = async ({ fetchDienstleistungIfNeeded, serviceUrl, serviceId }) => {
    await Promise.all([fetchDienstleistungIfNeeded({ serviceUrl, serviceId })]);
};

const mapStateToProps = (state, { match }) => {
    const { params } = match;
    const { serviceUrl, serviceId } = params;
    return {
        serviceId,
        serviceUrl,
        markenStandort: markenStandortSelector(state),
        standortUrl: standortUrlSelector(state),
        dienstleistungResponse: dienstleistungResponseSelector(state, params),
        sessionId: sessionIdSelector(state),
    };
};

const mapDispatchToProps = dispatch => bindActionCreators({ addService, fetchDienstleistungIfNeeded }, dispatch);

export default withStandortRouter(
    withCookies(connect(mapStateToProps, mapDispatchToProps)(frontloadConnect(frontload, { onUpdate: true })(ServiceDetail)))
);
